module.exports = __webpack_public_path__ + "static/img/YANGXZ.4c3f274d.jpg";